import type { ReduxApplicationState } from '../combinedReducer';

export const selectPartnerInsights = (state: ReduxApplicationState) => state.partner.insights;
